import { render, staticRenderFns } from "./sgnav.vue?vue&type=template&id=70b61dea&scoped=true"
import script from "./sgnav.vue?vue&type=script&lang=js"
export * from "./sgnav.vue?vue&type=script&lang=js"
import style0 from "./sgnav.vue?vue&type=style&index=0&id=70b61dea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b61dea",
  null
  
)

export default component.exports